<template>
  <v-container id="locations-settings" fluid>
    <v-card outlined>
      <v-tabs grow>
        <v-tab>{{ $t('location.globalSpecificClosures') }}</v-tab>
        <v-tab>{{ $t('location.serviceHoursSettings') }}</v-tab>
        <v-tab-item eager>
          <global-special-closures
              ref="globalSpecialClosures"
              :loadedSettings="loadedSettings"
              :loading="loading">
          </global-special-closures>
        </v-tab-item>
        <v-tab-item eager>
          <v-container fluid>
            <v-card outlined class="mb-5">
              <v-card-title style="word-break: normal !important">
                {{ $t('location.serviceHoursSettings') }}
              </v-card-title>
              <v-container fluid>
                <v-row class="pl-sm-7 pb-7">
                  <v-col cols="12">
                    <v-switch
                      :input-value="enabledServices.preparation"
                      :label="$t('location.activatePreparationHours')"
                      :messages="$t('location.activatePreparationHoursMessage')"
                      @change="toggleService('preparation')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      :input-value="enabledServices.appointment"
                      :label="$t('location.activateAppointmentHours')"
                      :messages="$t('location.activateAppointmentHoursMessage')"
                      @change="toggleService('appointment')"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-container>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            class="ma-2 text-uppercase"
            color="primary"
            outlined
            :loading="loading"
            @click="updateSettings"
        > {{ $t("settings.update") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

import GlobalSpecialClosures from '../../components/locations/GlobalSpecialClosures.vue'
import {LocationService} from '@/services/locationService'


export default {
  name: "LocationsSettings",
  components: {
    GlobalSpecialClosures
  },
  data() {
    return {
      loading: false,
      loadedSettings: {}
    }
  },
  mounted() {
    this.getSettings()
  },
  computed: {
    enabledServices() {
      const services = this.loadedSettings.hours?.displayed_services
      if (!Array.isArray(services)) return {}
      return {
        preparation: services.includes('preparation'),
        appointment: services.includes('appointment'),
      }
    },
  },
  methods: {
    async getSettings() {
      this.loading = true
      this.$set(this.loadedSettings, 'globalSpecialClosures', [])
      this.$set(this.loadedSettings, 'hours', {})
      try {
        let res = await LocationService.getSettings(this.$auth.accessToken)
        this.$set(this.loadedSettings, 'globalSpecialClosures', res.global_special_closures)
        this.$set(this.loadedSettings, 'hours', res.hours || {})
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    toggleService(service) {
      if (!this.loadedSettings.hours?.displayed_services) {
        this.$set(this.loadedSettings, 'hours', { displayed_services: [] })
      }
      let services = [...this.loadedSettings.hours.displayed_services]
      if (!services.includes(service)) {
        services.push(service)
      } else {
        services = services.filter((s) => s !== service)
      }

      this.$set(this.loadedSettings.hours, 'displayed_services', services)
    },
    async updateSettings() { // update settings with new values
      this.loading = true
      await LocationService.updateSettings(this.$auth.accessToken, this.loadedSettings)
      this.loading = false
    }
  },
}
</script>
